import { ActionType, getType } from 'typesafe-actions'

import N from '../../utils/assert-never'
import * as actions from './actions'
import { initial as initialState, Type as State } from './state'

export type Action = ActionType<typeof actions>

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  switch (action.type) {
    case getType(actions.makeCreative):
      return {
        ...state,
        making: true,
      }
    case getType(actions.makeCreativeComplete):
      return {
        ...state,
        making: false,
      }
    case getType(actions.getCreative):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.getCreativeComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          return {
            ...state,
            creative: action.payload.payload,
            loading: false,
          }
        } else {
          return state
        }
      } else {
        return state
      }

    case getType(actions.doCreativeAction):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.doCreativeActionComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          const newCreative = action.payload.payload.creative

          return {
            ...state,
            loading: false,
            creative: {
              ...newCreative,
              project:
                state.creative !== null ? state.creative.project : undefined,
            },
          }
        } else {
          return {
            ...state,
            loading: false,
            error: action.payload.payload.message,
          }
        }
      } else {
        return state
      }

    case getType(actions.setCreativeComment):
      if ('payload' in action) {
        return { ...state }
      } else {
        return state
      }

    case getType(actions.setCreativeCommentComplete):
      if ('payload' in action && state.creative !== null) {
        return {
          ...state,
          creative: {
            ...state.creative,
            comment:
              action.payload.type === 'success'
                ? action.payload.payload
                : state.creative.comment,
          },
        }
      } else {
        return state
      }

    case getType(actions.leaveCreativePage):
      return {
        ...state,
        creative: null,
      }
  }

  return N(action, state)
}
